import { api } from "../helpers/apiHelper";
//
const API_DOCUMENTS = "/account/documents";
const API_REGISTRATION = "/registration";

/**
 * Upload document
 */
export const uploadDocument = (data: Record<string, any>): any => {
  const url = API_DOCUMENTS;
  return api.post(url, data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

/**
 * Get list of documents for logged in user
 */
export const getDocumentList = (): any => {
  const url = API_DOCUMENTS;
  return api.get(url);
};

export const getDocumentListPromise = (): Promise<any> => {
  const url = API_DOCUMENTS;
  return new Promise((resolve, reject) => {
    api
      .get(url)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/**
 * Delete a document
 */
export const deleteDocument = async (id: number) => {
  const url = `${API_DOCUMENTS}/${id}/delete`;
  try {
    const resp = await api.delete(url);
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    } else {
      throw new Error(`Deletion failed with status ${resp.status}`);
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Start Verification
 */
export const startVerification = (): any => {
  const url = `${API_REGISTRATION}/verify`;
  return api.post(url, {});
};

export const startVerificationMOCK = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (Math.random() < 0.5) {
        // Simulate success 80% of the time
        resolve({
          status: 200,
          data: { message: "Verification started successfully" },
        });
      } else {
        reject({
          response: {
            status: 400, // Example error status code
            data: { message: "Error. Please contact support." },
          },
        });
      }
    }, 10000);
  });
};
